import { Component, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TeamShortDto } from "app/models";
import { TeamService } from "app/services";

@Component({
    selector: 'national-team-short-modal',
    templateUrl: './national-team-short.modal.html',
    styleUrls: ['./national-team-short.modal.scss'],
})
export class NationalTeamShortModal implements OnInit {
    @Input() team: TeamShortDto;

    formGroup: FormGroup;

    constructor(public activeModal: NgbActiveModal, private teamService: TeamService) {
    }
    
    ngOnInit(): void {
        this.formGroup = new FormGroup({
            teamFormControl: new FormControl(),
        });
    }

    loadTeam() {
        console.log(this.formGroup.controls.teamFormControl.value);
        if (this.formGroup.controls.teamFormControl.value) {
            this.teamService.getNationalShortTeam(this.formGroup.controls.teamFormControl.value)
                .subscribe(result => {
                    this.team = result;
                })
        }
    }

    onSubmit() {
        if (this.formGroup.controls.teamFormControl.value) {
            this.activeModal.close(this.team);
        }
    }
}